import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import appSlice from './appSlice';
import expenseFormSlice from '../components/ExpenseForm/expenseFormSlice';
import adminReducer from '../features/AdminPortal/adminSlice';
import addClientUserSlice from '../features/ClientAccess/AddClientUser/addClientUserSlice';
import clientAccessReducer from '../features/ClientAccess/clientAccessSlice';
import appAccessSlice from '../features/ClientAccess/EditAccess/appAccessSlice';
import dashboardReducer from '../features/Dashboard/dashboardSlice';
import assembleNewDQFSlice from '../features/DriverQualification/AssembleNewDQF/assembleNewDQFSlice';
import driverQualificationReducer from '../features/DriverQualification/driverQualificationSlice';
import newRequestReducer from '../features/DriverQualification/ListDQ/NewRequest/newRequestSlice';
import checkListSlice from '../features/DriverQualification/Management/ChecklistDetails/checkListSlice';
import checklistTemplatesSlice from '../features/DriverQualification/Management/ChecklistTemplates/checklistTemplatesSlice';
import qualificationListSlice from '../features/DriverQualification/Management/QualificationList/qualificationListSlice';
import standardDocumentSlice from '../features/DriverQualification/Management/StandardDocument/standardDocumentSlice';
import standardDocumentsSlice from '../features/DriverQualification/Management/StandardDocuments/standardDocumentsSlice';
import selectDocumentSlice from '../features/DriverQualification/SelectDocumentDetails/selectDocumentSlice';
import viewDQFSlice from '../features/DriverQualification/ViewDQF/viewDQFSlice';
import searchExpensesFormSlice from '../features/ExpenseEntry/DriverSolutions/SearchExpenses/searchExpensesFormSlice';
import expensesEntrySlice from '../features/ExpenseEntry/expensesEntrySlice';
import clericalSlice from '../features/QuoteEngine/GenerateQuote/Clerical/clericalSlice';
import driversSlice from '../features/QuoteEngine/GenerateQuote/Drivers/driversSlice';
import myQuotesSlice from '../features/QuoteEngine/MyQuotes/myQuotesSlice';
import quoteEngineReducer from '../features/QuoteEngine/quoteEngineSlice';
import viewQuoteSlice from '../features/QuoteEngine/ViewQuote/viewQuoteSlice';

const persistConfig = {
  key: 'root',
  blacklist: [
    'appAccess',
    'expenseForm',
    'expenseEntry',
    'admin',
    'clientAccess',
    'newRequest',
    'viewDQF',
    'assembleNewDQF',
    'checkList',
    'driverQualification',
  ],
  storage,
};

const rootReducer = combineReducers({
  addClientUser: addClientUserSlice,
  admin: adminReducer,
  appAccess: appAccessSlice,
  checkList: checkListSlice,
  checklistTemplates: checklistTemplatesSlice,
  qualificationList: qualificationListSlice,
  clientAccess: clientAccessReducer,
  dashboard: dashboardReducer,
  driverQualification: driverQualificationReducer,
  expenseEntry: expensesEntrySlice,
  myQuotes: myQuotesSlice,
  newRequest: newRequestReducer,
  standardDocument: standardDocumentSlice,
  standardDocuments: standardDocumentsSlice,
  quoteEngine: quoteEngineReducer,
  quoteEngineDrivers: driversSlice,
  quoteEngineClerical: clericalSlice,
  viewQuote: viewQuoteSlice,
  viewDQF: viewDQFSlice,
  expenseForm: expenseFormSlice,
  assembleNewDQF: assembleNewDQFSlice,
  selectDocumentDetails: selectDocumentSlice,
  app: appSlice,
  searchExpensesForm: searchExpensesFormSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export default store;
